<template>
<svg version="1.1" id="Calque_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
     viewBox="0 0 300 300" style="enable-background:new 0 0 300 300;" xml:space="preserve">

<path class="st0" d="M102,102c-9.7,0-18.5-5.8-22.2-14.8c-3.7-9-1.7-19.3,5.2-26.2c6.9-6.9,17.2-8.9,26.2-5.2
    c9,3.7,14.8,12.5,14.8,22.2c0,6.4-2.5,12.5-7,17C114.5,99.5,108.4,102,102,102L102,102z M60,132v45c0,5,4,9,9,9h9v54
    c0,1.6,0.6,3.1,1.8,4.2s2.6,1.8,4.2,1.8h36c1.6,0,3.1-0.6,4.2-1.8s1.8-2.6,1.8-4.2v-54h9c5,0,9-4,9-9v-45c0-9.9-8.1-18-18-18
    l-24,16.8L78,114C68.1,114,60,122.1,60,132L60,132z"/>
<path class="st1" d="M210,115.8h-12c-3.3,0-6,2.7-6,6v24h-24c-3.3,0-6,2.7-6,6v12c0,1.6,0.6,3.1,1.8,4.2s2.6,1.8,4.2,1.8h24v24
    c0,1.6,0.6,3.1,1.8,4.2s2.6,1.8,4.2,1.8h12c1.6,0,3.1-0.6,4.2-1.8s1.8-2.6,1.8-4.2v-24h24c1.6,0,3.1-0.6,4.2-1.8s1.8-2.6,1.8-4.2
    v-12c0-1.6-0.6-3.1-1.8-4.2s-2.6-1.8-4.2-1.8h-24v-24c0-1.6-0.6-3.1-1.8-4.2S211.6,115.7,210,115.8L210,115.8z"/>
</svg>

</template>

<script>
export default {
    name: 'IconEvalNew',
}
</script>

<style lang="scss" scoped>

    .st0{fill:none;stroke:#909AAA;stroke-width:6;stroke-miterlimit:10;}
    .st1{fill:#909AAA;}

</style>